import { Injectable } from '@angular/core';
import { ApiService } from '../http/api.service';
import { Companie } from '../models/companie.model';
import { InfoMotel } from '../models/infoMotel.model';

@Injectable({ providedIn: 'root' })
export class CompanieService {
  constructor(
    private apiService: ApiService,
  ) {}

  async allCompanies(): Promise<Companie[]> {
    const response = await this.apiService.apiGet('/v1/company');
    return response as Companie[];
  }

  async getAllCompaniesNoteLinkedWithHolding(idHolding: string): Promise<Companie[]> {
    const response = await this.apiService.apiGet(`/v1/company/get-not-linked-with-holding/${idHolding}`);
    return response as Companie[];
  }

  async getAllCompaniesNoteLinkedWithUser(idUser: string): Promise<Companie[]> {
    const response = await this.apiService.apiGet(`/v1/company/get-not-linked-with-user/${idUser}`);
    return response as Companie[];
  }

  async getAllCompaniesNotInVersion(idVersion: string): Promise<Companie[]> {
    const response = await this.apiService.apiGet(`/v1/company/get-not-linked-with-version/${idVersion}`);
    return response as Companie[];
  }

  async getAllCompaniesInVersion(idVersion: string): Promise<Companie[]> {
    const response = await this.apiService.apiGet(`/v1/company/get-linked-with-version/${idVersion}`);
    return response as Companie[];
  }

  async getAllCompanies(): Promise<Companie[]> {
    const response = await this.apiService.apiGet('/v1/company/company-all-to-admin');
    return response as Companie[];
  }

  async getAllCompaniesInfo(): Promise<Companie[]> {
    try {
      const response = await this.apiService.apiGet('/v1/company/company-all-info-to-admin');
      return response as Companie[];
    } catch (error) {
      console.error('Error fetching companies:', error);
      throw error;
    }
  }

  async getAllCompaniesByHolding(idHolding: string): Promise<Companie[]> {
    const response = await this.apiService.apiGet(`/v1/company-by-holding/${idHolding}`);
    return response as Companie[];
  }

  async getAllCompaniesByUserToAdmin(idUser: string): Promise<Companie[]> {
    const response = await this.apiService.apiGet(`/v1/company/company-by-user-to-admin/${idUser}`);
    return response as Companie[];
  }

  async createCompany(object: any): Promise<any> {
    return await this.apiService.apiPost('/v1/company', object).toPromise();
  }

  async updateCompany(object: any, idCompany: string): Promise<any> {
    return await this.apiService.apiPut(`/v1/company/${idCompany}`, object).toPromise();
  }

  async getInfoMotelByCompany(idCompany: string): Promise<InfoMotel> {
    const response = await this.apiService.apiGet(`/v1/info-motel/get-by-company/${idCompany}`);
    return response as InfoMotel;
  }

  async updateInfoMotel(idCompany: string, object: any): Promise<any> {
    return await this.apiService.apiPut(`/v1/info-motel/${idCompany}`, object).toPromise();
  }

  async regenerateApiToken(actualId: string): Promise<any> {
    return await this.apiService.apiGet(`/v1/company/regenerate-api-token/${actualId}`);
  }

  async removeAllData(idCompany: string): Promise<any> {
    return await this.apiService.apiPost(`/v1/company/removeAllData/${idCompany}`, {}).toPromise();
  }

  async deleteCompanyMonitor(id: string): Promise<any> {
    return await this.apiService.apiPost('/v1/infoMotel/remove', { company_id: id }).toPromise();
  }

  async deleteCompany(idCompany: string): Promise<any> {
    try {
      return await this.apiService.apiDelete('/v1/company/remove', idCompany).toPromise();
    } catch (error) {
      console.error('Error deleting company:', error);
      throw error;
    }
  }

  async getCompanie(id: string): Promise<Companie> {
    const response = await this.getAllCompanies();
    const companie = response.filter(companie => companie.id === id);
    return companie[0];
  }

  async updateUserAdmin(idCompany: string, idUser: string): Promise<any> {
    return await this.apiService.apiPost(`/v1/user/update-user-admin-by-company/${idCompany}`, {user: idUser}).toPromise();
  }
}
